import { RecommendationsUserItem } from './UserMenu/UserMenuItems'
import UserMenuLink from './UserMenu/UserMenuLink'

interface Props {
  hasRecommendations: boolean
}

const RecommendationsPageLink = ({ hasRecommendations }: Props) => {
  if (!hasRecommendations) return null

  return <UserMenuLink userItem={RecommendationsUserItem} />
}

export default RecommendationsPageLink
